window.Foundation.registerExtension(($elem) => {
  window.setTimeout(() => {
    $elem.find('[data-autofocus]').first().focus();
  }, 0);
});
